<div class="email-limits" [formGroup]="limitGroup">
  <div class="col2-layout">
    <span class="label">Messages per day:</span>

    <app-number-input2
      class="number-input"
      [minimum]="1"
      [maximum]="200"
      formControlName="messagesPerDay"></app-number-input2>
  </div>

  <div class="radio-item">
    <label (click)="(null)">
      <input
        #fixedDelayRadio
        type="radio"
        name="delayType"
        value="fixed"
        formControlName="delayType" />

      <app-radio class="radio" [checked]="fixedDelayRadio.checked"></app-radio>

      <span class="label">Fixed delay between emails</span>
    </label>
  </div>

  <div class="col2-layout">
    <span class="label">Seconds:</span>

    <app-number-input2
      class="number-input"
      [minimum]="5"
      [maximum]="3600"
      formControlName="delay"></app-number-input2>
  </div>

  <div class="radio-item">
    <label (click)="(null)">
      <input
        #randomDelayRadio
        type="radio"
        name="delayType"
        value="random"
        formControlName="delayType" />

      <app-radio [checked]="randomDelayRadio.checked" class="radio"></app-radio>

      <span class="label">Random delay between emails</span>
    </label>
  </div>

  <div class="col2-layout">
    <span class="label">Seconds:</span>

    <div class="range">
      <app-number-input2
        class="number-input"
        formControlName="randomDelayFrom"
        [minimum]="5"
        [maximum]="3600"></app-number-input2>

      <span class="delimiter">to</span>

      <app-number-input2
        class="number-input"
        formControlName="randomDelayTo"
        [minimum]="5"
        [maximum]="3600"></app-number-input2>
    </div>
  </div>
</div>
